import { PROFESSIONAL_SECTIONS_ANCHOR } from '~/modules/professional/util/constants';

interface CategoryProfessional {
    Link: string;
    URLSegment: string;
}

interface Category {
    Link: string;
}

/**
 * Build a professional products URL filtered to a product category.
 */
export const getProductCategoryUrl = (
    professional: CategoryProfessional,
    category: Category,
): string => {
    const professionalProducts = `${professional.Link}/our-products`;
    const searchParams = new URLSearchParams();

    if (category.Link) {
        searchParams.set('categoryLink', category.Link);
    }

    if (professional.URLSegment) {
        searchParams.set('professionals', professional.URLSegment);
    }

    const params = searchParams.toString();

    return params
        ? `${professionalProducts}?${params}#${PROFESSIONAL_SECTIONS_ANCHOR}`
        : professionalProducts;
};
